// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"488":"dc6b5553","551":"62cd7f53","842":"0cc98c7e","851":"b8ad0e9c"}[chunkId] + ".chunk.js";
};